import { render, staticRenderFns } from "./CoursesUpdate.vue?vue&type=template&id=7d694c1d"
import script from "./CoursesUpdate.vue?vue&type=script&lang=js"
export * from "./CoursesUpdate.vue?vue&type=script&lang=js"
import style0 from "./CoursesUpdate.vue?vue&type=style&index=0&id=7d694c1d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports